import React from "react";
import { useNavigate } from "react-router-dom";

function GuidePage() {
  const navigate = useNavigate();

  const sectionStyle = {
    background: "#ffffff",
    borderRadius: 18,
    padding: 28,
    marginBottom: 24,
    border: "1px solid #e6ecf5",
    boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
  };

  const headingStyle = {
    marginTop: 0,
    marginBottom: 14,
    color: "#0f172a",
    fontSize: 24,
    fontWeight: 800,
  };

  const textStyle = {
    color: "#475569",
    lineHeight: "30px",
    fontSize: 16,
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f4f8ff",
        padding: "40px 24px",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 980,
          margin: "0 auto",
        }}
      >
        <div
          style={{
            marginBottom: 32,
            textAlign: "center",
          }}
        >
          <img
            src="/buildcarboniq-logo.png"
            alt="BuildCarbonIQ"
            style={{
              width: 260,
              marginBottom: 18,
            }}
          />

          <h1
            style={{
              marginBottom: 12,
              color: "#0f172a",
              fontSize: 42,
              fontWeight: 800,
            }}
          >
            How BuildCarbonIQ Works
          </h1>

          <p
            style={{
              maxWidth: 760,
              margin: "0 auto",
              color: "#475569",
              fontSize: 18,
              lineHeight: "34px",
            }}
          >
            BuildCarbonIQ converts Bills of Quantities and material schedules
            into embodied carbon assessments using governed lifecycle carbon datasets.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Current Assessment Boundary</h2>

          <div style={textStyle}>
            <p>
              BuildCarbonIQ currently supports A1-A3 embodied carbon assessment.
            </p>

            <p>
              Included:
            </p>

            <ul>
              <li>Raw material extraction</li>
              <li>Material manufacturing</li>
              <li>Factory processing emissions</li>
            </ul>

            <p>
              Not yet included:
            </p>

            <ul>
              <li>Operational energy</li>
              <li>Transport to site</li>
              <li>Construction activities</li>
              <li>Maintenance</li>
              <li>Demolition and end-of-life</li>
            </ul>
          </div>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Recommended Input Files</h2>

          <div style={textStyle}>
            <ul>
              <li>Excel Bills of Quantities (.xlsx)</li>
              <li>Material schedules</li>
              <li>Quantity-based construction data</li>
            </ul>

            <p>
              Ensure:
            </p>

            <ul>
              <li>Headers are on row 1</li>
              <li>No merged cells</li>
              <li>No duplicate columns</li>
              <li>Data begins from row 2</li>
            </ul>
          </div>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Assessment Workflow</h2>

          <div style={textStyle}>
            <p>
              1. Upload BoQ or material list
            </p>

            <p>
              2. Ingest and classify materials
            </p>

            <p>
              3. Run embodied carbon assessment
            </p>

            <p>
              4. Lock assessment run
            </p>

            <p>
              5. Download PDF report
            </p>
          </div>
        </div>

        <div style={sectionStyle}>
          <h2 style={headingStyle}>Understanding Results</h2>

          <div style={textStyle}>
            <p>
              Results are reported in kgCO2e (kilograms of carbon dioxide equivalent).
            </p>

            <p>
              The platform identifies:
            </p>

            <ul>
              <li>High-emission materials</li>
              <li>Carbon hotspots</li>
              <li>Governed dataset coverage</li>
              <li>Lifecycle contribution breakdowns</li>
            </ul>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: 40,
          }}
        >
          <button
            onClick={() => navigate("/dashboard")}
            style={{
              background: "linear-gradient(135deg, #0f5eea, #39bdf8)",
              color: "#ffffff",
              border: "none",
              padding: "18px 34px",
              borderRadius: 14,
              cursor: "pointer",
              fontWeight: 800,
              fontSize: 18,
              boxShadow: "0 10px 24px rgba(37,99,235,0.30)",
            }}
          >
            Proceed to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default GuidePage;